// extracted by mini-css-extract-plugin
module.exports = {"menuButtonDisabled":"MenuTextButton_menu-button-disabled__1sR_E","menuButton":"MenuTextButton_menu-button__2-V1X","menuButtonIcon":"MenuTextButton_menu-button-icon__3pvG_"};